import React, { useEffect } from 'react';
import ProductExport from "../../components/admin/product/components/ProductExport";
import PersistentDrawerLeft from "../../components/reusable/admin/Main";
import { jwtDecode } from "jwt-decode";
import { WEB_BASE_URL } from '../../constants';

const ProductExportComp = () => {
  const token:string = localStorage.getItem("token") ? ""+localStorage.getItem("token")+"" : "";
  const decoded:{id: number; role: string;} = jwtDecode(token);
  return (
    decoded.role === "ADMIN" ?
    <div>
    <PersistentDrawerLeft>
      <ProductExport/>
   </PersistentDrawerLeft>
    </div> : null
  );
};

export default ProductExportComp;